import { SET_REVIEWS_COURSES, SET_REVIEWS_CURRENT, SET_REVIEWS_LIST, SET_REVIEWS_LOADING, SET_REVIEWS_TEACHERS } from "./types";
import { BACKEND_URL_PREFIX, itemsOnPage } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import { createNotification } from "../components/notifications/notifications";




export const getList = (search, pageNumber) => async (dispatch, getState) => {
  dispatch({ type: SET_REVIEWS_LOADING, payload: true });
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const offset = itemsOnPage * pageNumber;
    const limit = itemsOnPage;
    const params = { limit, offset, search }
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/reviews/statistics?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    
    if (response.ok) {
      const { count, statistics } = await response.json();
      const pageCount = Math.ceil(count / itemsOnPage);
      dispatch({type: SET_REVIEWS_LIST, payload: statistics, pageCount});
    }
  }
  dispatch({ type: SET_REVIEWS_LOADING, payload: false });
};

export const getCurrent = (id, pageNumber) => async (dispatch, getState) => {
  dispatch({ type: SET_REVIEWS_LOADING, payload: true });
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const offset = itemsOnPage * pageNumber;
    const limit = itemsOnPage;
    const params = { limit, offset }
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/reviews/teacher/${id}?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    
    if (response.ok) {
      const {count_reviews, ...payload} = await response.json();
      const pageCount = Math.ceil(count_reviews / itemsOnPage);
      dispatch({type: SET_REVIEWS_CURRENT, payload, pageCount});
    }
  }
  dispatch({ type: SET_REVIEWS_LOADING, payload: false });
}

export const createReview = (data) => async (dispatch, getState) => {
  let returnState 
  try {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/reviews`,
        {
          method: "POST",
          body: JSON.stringify(data),
          ...buildDefaultHeaders(getState)
        }
      );
      if (response.ok) {
        returnState = true
      } else {
        const {error} = await response.json();
        error && createNotification('error', error);
      }
    }
  } finally {
    return returnState
  }
}

export const createVote = (data) => async (dispatch, getState) => {
  let returnState = {}
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/reviews/vote`,
      {
        method: "POST",
        body: JSON.stringify(data),
        ...buildDefaultHeaders(getState)
      }
    );
    if (response.ok) {
      const { vote } = await response.json()
      returnState = vote
    }
  }
  return returnState
}

export const getCourses = (idcathedra) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const searchParams = idcathedra ? {idcathedra} : {}
    const urlParams = new URLSearchParams(searchParams).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/teacher_reviews/meta_course?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    
    if (response.ok) {
      const payload = await response.json();
      dispatch({type: SET_REVIEWS_COURSES, payload});
    }
  }
};

export const getTeachers = (pageNumber, idcathedra, meta_course, search) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const offset = itemsOnPage * pageNumber;
    const limit = itemsOnPage;
    const searchParams = { limit, offset, idcathedra, meta_course, search }
    const urlParams = new URLSearchParams(searchParams).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/teacher_reviews/users?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    
    if (response.ok) {
      const {count, result} = await response.json();
      const pageCount = Math.ceil(count / itemsOnPage);
      dispatch({type: SET_REVIEWS_TEACHERS, payload: result, pageCount});
    }
  }
};